import React from 'react'
import { Col, Row } from 'antd'
import AppointmentCard from './AppointmentCard'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'

const Cards = ({ appointments }) => {
  const screens = useBreakpoint()
  const span = screens.xs ? 24 : 6
  const result = []
  appointments.forEach((appointment) => {
    result.push(<Col span={span} key={appointment.id}><AppointmentCard appointment={appointment} /></Col>)
  })
  return result
}

export default function AppointmentCards ({ appointments }) {
  const pad = { xs: 8, sm: 16, md: 24, lg: 32 }
  return (
    <Row gutter={[pad, pad]} justify="center">
      <Cards appointments={appointments} />
    </Row>
  )
}
